import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Codenames from './pages/Codenames';
import CodenamesDuet from './pages/CodenamesDuet';
import Decrypto from './pages/Decrypto';
import Wavelength from './pages/Wavelength';
import DesiMonikers from './components/desi-monikers/DesiMonikers';

function App() {
  return (
    <Router basename="/board-games-bond">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/codenames" element={<Codenames />} />
        <Route path="/codenames/:gameCode" element={<Codenames />} />
        <Route path="/codenames-duet" element={<CodenamesDuet />} />
        <Route path="/codenames-duet/:gameCode" element={<CodenamesDuet />} />
        <Route path="/decrypto" element={<Decrypto />} />
        <Route path="/decrypto/:gameCode" element={<Decrypto />} />
        <Route path="/wavelength" element={<Wavelength />} />
        <Route path="/wavelength/:gameCode" element={<Wavelength />} />
        <Route path="/desi-monikers" element={<DesiMonikers />} />
      </Routes>
    </Router>
  );
}

export default App;
